import { render, staticRenderFns } from "./SatuanUnitObat.vue?vue&type=template&id=d46c62a6"
import script from "./SatuanUnitObat.vue?vue&type=script&setup=true&lang=js"
export * from "./SatuanUnitObat.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports